const indexItems = [
  { id: 1, letter: 'A', name: '爱豆塌房实录', count: '47篇', color: 'text-primary-500 bg-primary-500/10' },
  { id: 2, letter: 'B', name: '暴走黑料合集', count: '89篇', color: 'text-accent-500 bg-accent-500/10' },
  { id: 3, letter: 'C', name: 'CP营业翻车', count: '32篇', color: 'text-secondary-500 bg-secondary-500/10' },
  { id: 4, letter: 'D', name: '代言风波汇总', count: '56篇', color: 'text-primary-500 bg-primary-500/10' },
  { id: 5, letter: 'H', name: '黑料社精选', count: '104篇', color: 'text-accent-500 bg-accent-500/10' },
  { id: 6, letter: 'S', name: '综艺争议合集', count: '63篇', color: 'text-secondary-500 bg-secondary-500/10' },
  { id: 7, letter: 'W', name: '网红观察日记', count: '78篇', color: 'text-primary-500 bg-primary-500/10' },
  { id: 8, letter: 'Y', name: '艺人片酬揭秘', count: '41篇', color: 'text-accent-500 bg-accent-500/10' },
  { id: 9, letter: 'Z', name: '综艺剧本泄露', count: '35篇', color: 'text-secondary-500 bg-secondary-500/10' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
            专题索引
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            按字母排序的暴走黑料与黑料社内容专题速查
          </p>
        </div>

        <div className="max-w-4xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((item) => (
            <div
              key={item.id}
              className="flex items-center gap-4 p-4 bg-background-100 rounded-xl border border-background-200/60 hover:border-primary-500/30 transition-all cursor-pointer group"
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${item.color}`}>
                {item.letter}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
                  {item.name}
                </h3>
                <span className="text-xs text-foreground-400">{item.count}</span>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}